import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=088ad438&scoped=true&lang=pug"
import script from "./icon-button.vue?vue&type=script&lang=js"
export * from "./icon-button.vue?vue&type=script&lang=js"
import style0 from "./icon-button.vue?vue&type=style&index=0&id=088ad438&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ad438",
  null
  
)

export default component.exports